import labIcon from "@assets/icons/menuIcons/labicon.svg"
import saffron from "@assets/icons/menuIcons/Zafaron.svg"
import sowing from "@assets/icons/menuIcons/cultivar.svg"
import cultivar from "@assets/icons/menuIcons/harvest.svg"
import harvest from "@assets/icons/menuIcons/cultivar.svg"
import planIcon from "@assets/icons/menuIcons/planicon.svg"
import visitIcon from "@assets/icons/menuIcons/visiticon.svg"
import yieldgap from "@assets/icons/menuIcons/yieldGapIcon.svg"
import weatherIcon from "@assets/icons/menuIcons/weathericon.svg"
import undefinedIcon from "@assets/icons/menuIcons/icons8-undefined-100.png"
import chillingRequirementIcon from "@assets/icons/menuIcons/chillingrequirement.svg"

import moment from "jalali-moment"


export function factorData(factors) {
  return factors
}


export function paymentButton(status) {

  switch (status) {

    case "PENDING":
      return "پرداخت"

    case "PAID":
      return "جزئیات"

    default:
      return "نامشخص"
  }
}

export function paymentButtonColor(status) {

  switch (status) {

    case "PENDING":
      return "!text-green-700"

    case "PAID":
      return "!text-agrotext"

    default:
      return "!text-agrotext"
  }
}

export function detailInvoice(category) {
  switch (category) {

    case "WEATHER_STATION":
      return "ایستگاه هواشناسی"

    case "QUESTIONNAIRE":
      return "برنامه کودی"

    case "VISIT":
      return "درخواست بازدید"

    case "EXPERIMENT":
      return "درخواست آزمایش"

    case "YIELD_GAP":
      return "خلأ عملکرد"

    case "CHILLING_REQUIREMENT":
      return "تعیین نیاز سرمایی"

    case "HARVEST_DATE_RECOMMENDATION":
      return "تعیین تاریخ برداشت"

    case "SOWING_DATE_RECOMMENDATION":
      return "تعیین تاریخ کاشت"

    case "CULTIVAR_RECOMMENDATION":
      return "انتخاب رقم مناسب"

    case "FIRST_SAFFRON_IRRIGATION_DATE_RECOMMENDATION":
      return 'آبیاری اول زعفران'

    default:
      return "نامشخص"
  }
}

export function categoryIcon(category) {
  switch (category) {

    case "WEATHER_STATION":
      return weatherIcon

    case "QUESTIONNAIRE":
      return planIcon

    case "VISIT":
      return visitIcon

    case "EXPERIMENT":
      return labIcon

    case "YIELD_GAP":
      return yieldgap

    case "CHILLING_REQUIREMENT":
      return chillingRequirementIcon

    case "SOWING_DATE_RECOMMENDATION":
      return sowing

    case "HARVEST_DATE_RECOMMENDATION":
      return harvest

    case "CULTIVAR_RECOMMENDATION":
      return cultivar

    case "FIRST_SAFFRON_IRRIGATION_DATE_RECOMMENDATION":
      return saffron

    default:
      return undefinedIcon
  }
}

export function hejriDate(date) {
  if (date) {
    const hejriDate = moment(date, "YYYY-MM-DD").locale('fa')
      .format("YYYY/MM/DD")
    return hejriDate
  } else {
    return ''
  }
}

export function nameServiceFarmerManagement(category) {
  switch (category) {
    case 'CULTIVAR_RECOMMENDATION':
      return 'انتخاب رقم مناسب'

    case 'HARVEST_DATE_RECOMMENDATION':
      return 'تعیین تاریخ برداشت'

    case 'YIELD_GAP':
      return 'خلا عملکرد'

    case 'CHILLING_REQUIREMENT':
      return 'تعیین نیاز سرمایی'

    case 'SOWING_DATE':
      return 'تعیین تاریخ کاشت'

    default:
      return 'نامشخص'
  }

}

export function logoServiceFarmerManagement(category) {
  switch (category) {
    case 'CULTIVAR_RECOMMENDATION':
      return cultivar

    case 'HARVEST_DATE_RECOMMENDATION':
      return harvest

    case 'YIELD_GAP':
      return yieldgap

    case 'CHILLING_REQUIREMENT':
      return chillingRequirementIcon

    case 'SOWING_DATE':
      return sowing

    case "FIRST_SAFFRON_IRRIGATION_DATE_RECOMMENDATION":
      return saffron

    default:
      return undefinedIcon
  }

}

export function routReportServiceFarmerManagement(category, navigate, id) {
  switch (category) {
    case 'CULTIVAR_RECOMMENDATION':
      return navigate(`/cultivar-recommendation/cultivar-recommendation-report/${id}`)

    case 'HARVEST_DATE_RECOMMENDATION':
      return navigate(`/harvest-recommendation/harvest-recommendation-report/${id}`)

    case 'YIELD_GAP':
      return navigate(`/yield-gaps/${id}`)

    case 'CHILLING_REQUIREMENT':
      return navigate(`/chilling-requirement/chilling-requirement-report/${id}`)

    case 'SOWING_DATE':
      return navigate(`/sowing-date-recommendation-report/${id}`)

    default:
      return navigate(`/my-fields/field_certificate/${id}`)
  }
} 